import BaseProxy from './Proxy';

export default class SubstoreOrderAdministrationActionProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/orderAdministrationAction', parameters);
  }
}
